import { FC } from "react";
import { SegmentType } from "src/Modules/Flights/constants";
import { SegmentCard } from "src/Modules/Flights/Pages/JourneyDetails/Steps/Details/components";

const FlightDetails: FC<{ segments: SegmentType[] }> = ({ segments }) => {
  return (
    <div className="bg-background-default flex flex-col rounded-sm shadow-sm p-5">
      <div className="flex flex-col gap-3">
        {segments?.map((segment, index) => (
          <div
            key={`segment-${index}`}
            className="rounded-sm! flex flex-col bg-background-default"
          >
            <SegmentCard segment={segment} segmentNumber={index} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlightDetails;
